import { render, staticRenderFns } from "./SuiteSettings.vue?vue&type=template&id=1c531530&"
import script from "./SuiteSettings.vue?vue&type=script&lang=js&"
export * from "./SuiteSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports